import React, { Component } from 'react';
import axios from 'axios';
import { roster_stats_heads } from '~/tools/mll/headers';
import { combineNames, labelIsValid } from '~/tools/mll/helpers';
import Spinner from '~/components/Spinner';
import '~/modules/TeamStats/styles.scss';
import Table from '~/components/Table';

class TeamRoster extends Component {
  state = {
    roster: [],
    loaded: false,
    items: this.props.data && this.props.data.metadataMap
  }

  componentDidMount = () => {
    const { items } = this.state
    axios.get(`/team-roster-standing/${items.teamId}/${items.seasonId}`)
    .then((res) => {
      const roster = res.data.rosters.teamroster.team;
      const initial = roster.players.player.concat(roster.goalies.goalie)
      const players = combineNames(initial, 'firstname', 'lastname')
      this.setState({
        roster: players,
        team: roster.teamname,
        loaded: true
      })
    }).catch((err) => {
      console.log(err);
    });
  }

  render() {
    const Height = ({ data, value }) => {
      return (
        <td>{ labelIsValid(data, value) ? data[value].replace(/(&apos;)|(&quot;)|-/g, '\'') : 'N/A'}</td>
      )
    }

    return (
      <div className="teamstats">
        <div className='teamstats-title site-border-color'>
          {`${new Date().getFullYear()} ${this.state.team || ''} Roster`}
        </div>
        { this.state.loaded ? 
          <Table 
            headers={roster_stats_heads[0]}
            data={this.state.roster}
            values={roster_stats_heads[1]}
            length={this.state.roster.length}
            filterTag='height'
            filter={Height}
          /> : <Spinner /> }
      </div>
    );
  }
}

export default TeamRoster;